import type { CognitoUserExt } from 'packages/workspace/services/models/account';
import type { IamPrincipal } from 'packages/workspace/services/models/session';
import { createContext, use } from 'react';
import useAuth from '../../prelude/useAuth';

export interface IAuthContext {
  loading: boolean;
  system_user: IamPrincipal | null;
  cognito_user: CognitoUserExt | null;
  error?: boolean;
}

const AuthContext = createContext<IAuthContext>({ loading: false, system_user: null, cognito_user: null, error: false });

/**
 * AuthCtx as Function.
 * Parth Ghiya
 */
export const useAuthCtx = (): IAuthContext => use(AuthContext);

/**
 * Auth Provider
 * @param param0
 */
export const AmplifyAuthProvider: React.FC = ({ children }) => {
  const { system_user, cognito_user, loading, error } = useAuth();
  return <AuthContext.Provider value={{ system_user, cognito_user, loading, error }}>{children}</AuthContext.Provider>;
};
